import type { SVGProps } from 'react';

const SvgId = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 5h-5V4c0-.55-.45-1-1-1s-1 .45-1 1v1H6C4.35 5 3 6.35 3 8v10c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3m1 13c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h5c0 .55.45 1 1 1s1-.45 1-1h5c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M16 9h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1m-.71 4.29c-.18.19-.29.45-.29.71s.11.52.29.71c.19.18.45.29.71.29s.52-.11.71-.29c.18-.19.29-.45.29-.71s-.11-.52-.29-.71c-.38-.37-1.04-.37-1.42 0m-2.9.51c.38-.5.61-1.12.61-1.8 0-1.65-1.35-3-3-3s-3 1.35-3 3c0 .68.23 1.3.61 1.8-.62.46-1.12 1.1-1.39 1.87a1.01 1.01 0 0 0 .94 1.34c.41 0 .8-.26.94-.67.28-.8 1.04-1.33 1.89-1.33s1.6.54 1.89 1.33c.18.52.76.79 1.28.61s.79-.76.61-1.28c-.27-.77-.76-1.4-1.39-1.87zM9 12c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1"
    />
  </svg>
);
export default SvgId;
